import React from 'react';
import '../base.css';
import './twitter.css';

const TweetButton = (props) => {
  const link = props.link ? props.link : encodeURIComponent(document.URL);
  const customClass = props.customStyle ? props.customStyle : '';

  return (
    <span className='item-btn'>
      <a
        className={`twitter share-button${customClass}`}
        target='_blank'
        rel='noopener noreferrer'
        href={`https://twitter.com/intent/tweet?text=${link}`}
      >
        <i className='fa fa-twitter' />
      </a>
    </span>
  );
};

export default TweetButton;
